import { ThemeProvider } from "@emotion/react";
import { Avatar, Card, CardContent, Container, createTheme, CssBaseline, Grid, Paper, Slide, Stack, Switch, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { renderToString } from 'react-dom/server';
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { setEmailBodyConfirmPayment } from "../../helpers/setEmailBodyConfirmPayment";
import { useFetchFacturaCats } from "../../hooks/useFetchFacturaCats";
import { getOneInByClave, getOneInById, getOneInByReferencia, putOneIn } from "../../services/crudCustom";
import { sendEmail } from "../../services/sendEmail";
import { uploadFile } from "../../services/uploadFile";
import { SendingDialog } from "../modules/dialogs/SendingDialog";
import { WaitDialog } from "../modules/dialogs/WaitDialog";
import { ButtonSubmit } from "../modules/ui/ButtonSubmit";
import { Footer } from "../modules/ui/Footer";
import { GroupRequireInvoice } from "../modules/ui/GroupRequireInvoice";
import { SelectCustom } from "../modules/ui/SelectCustom";
import { insertSolicitudFactura } from "../../services/insertSolicitudFactura";
import { reportError } from "../../services/reportError";
import { requestInvoice } from "../../services/store/requestInvoice";
import { getOneFromEduconCursosActivos } from "../../database/dbEduconCursosActivos";

//
// TODO: Reestructurar este modulo porque lo de facturar -invoice- debe ser un modulo independiente, incluyendo la pregunta de si es extranjero
//

export const ConfirmarRegistro = () => {
    // Hook que obtiene los parametros que se envian por la url
    let params = useParams();
    const { ref } = params;

    // state para cargar info
    const [isLoading, setIsLoading] = useState(false);
    
    // Para mostrar un dialogo mientras se envia la info (waiting dialog)
    const [sendingForm, setSendingForm] = useState(false);

    // Se ejecuta al cargarse la pagina y de acuerdo al _loading_ se muestra/oculta el dialog de "Cargando inf..."
    const { dataFPs, dataPaises } = useFetchFacturaCats();
    // console.log(loading);

    // state para los valores del formulario
    const [formValues, setFormValues] = useState({ 
        factExtranjero: "",
        factExtPais: "",
        factExtNombre: "",
        factExtConcepto: "",
    });
    const {
        partApellidoPaterno,
        partApellidoMaterno,
        partNombres,
        partCorreo,

        requiereFactura,
        factExtranjero,
        factExtPais,
        factExtNombre,
        factExtConcepto,
        factNombre,
        factRFC,
        factCP,
        factUsoCFDI,
        factRegimenFiscal,

        registroReferencia,
    } = formValues;


    // state para los valores del evento
    const [event, setEvent] = useState({ });

    // state para el fileupload
    const [file, setFile] = useState({
        file: '',
    });
    const setFileState = (e) => {    
        setFile({ file: e.target.files[0] });    
    };

    // state para la forma de pago
    const [detalles, setDetalles] = useState({
        formaPago: "",
        importe: "",
    });
    const { importe, formaPago } = detalles;

    const handleDetallesChange = ({ target }) => {

        setDetalles({
            ...detalles,
            [target.name]: target.value,
        });
    };

    // Para el swich de extranjero
    const [isForeigner, setIsForeigner] = useState(false);
    const handleSwitchForeigner = ({ target }) => {
        
        setIsForeigner(target.checked);

        setFormValues({
            ...formValues,
            [target.name]: target.checked,
        });
    };

    // Al modificar un dato en un input
    const handleInputChange = ({ target }) => {
        const { name, value } = target;

        setFormValues({
            ...formValues,
            [name]: value,
        });
    }


    // Submit form | Boton ENVIAR 
    const handleSubmit = async (event) => {
        event.preventDefault();
        // console.log({formValues});

        // No paso la validacion, deten el procesamiento
        if ( !isFormValid() ) { return false; }

        // TODO: Mostrar confirm dialog/waiting dialog
        Swal.fire({
            title: '¿Desea continuar?',
            text: "Por favor, confirme la información ingresada.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Regresar',
        }).then((result) => {
            if (result.isConfirmed) { continueConfirmed(); }
        })
    }

    // Validar el formumario
    const isFormValid = () => {

        // No ha indicado ningun archivo
        if ( file.file === '' ) {
            Swal.fire("Agregar documento.", `Por favor selecciona un archivo como comprobante.`, "error");
            return false;
        }
        // Indico archivo pero no es un PDF
        const fullName = file.file.name;
        const fileExt = fullName.substring( fullName.lastIndexOf('.') + 1 ).toUpperCase();
        if ( file.file !== '' && fileExt !== 'PDF' ) {
            Swal.fire("Documento incorrecto.", `El comprobante debe ser un archivo PDF.`, "error");
            return false;
        }
        // Indico archivo pero es muy grande
        if ( file.file.size > 2500000 ) {
            Swal.fire("Documento demasiado grande", `El comprobante debe ser menor a 2 MB.`, "error");
            return false;
        }

        // Campos obligatorios
        if ( [ formaPago, importe ].includes("") ) {
            Swal.fire("Indicar forma de pago e importe", "Los campos marcados con [ * ] son obligatorios.", "error");
            return false;
        }

        // Campos obligatorios
        if ( importe < 1 ) {
            Swal.fire("Indicar el importe correcto", "El dato debe ser un valor mayor que cero.", "error");
            return false;
        }

        if ( factExtranjero ) {
            // En caso de ser extranjero...
            if ( [ factExtPais, factExtNombre, factExtConcepto ].includes("") ) {
                Swal.fire("Datos incompletos", "Los campos marcados con [ * ] son obligatorios.", "error");
                return false;
            }   
        } else {
            // En caso de ser nacional y querer factura...
            if ( requiereFactura ) {
                if ( [ factNombre, factRFC, factCP, factUsoCFDI, factRegimenFiscal ].includes("") ) {
                    Swal.fire("Datos para facturación incompletos", "Los campos marcados con [ * ] son obligatorios.", "error");
                    return false;
                }  
            }
        }

        return true;
    }

    // Del sweetalert, cuando el usuario decide "continuar"
    const continueConfirmed = async() => {
        // Mostrar waiting dialog 
        setSendingForm(true);

        // Se procesa la info
        const resultDataProcessed = await isDataProcessed(); 

        // Ocultar waiting dialog
        setSendingForm(false);

        // Dependiendo el resultado se notifica al usuario...
        if (resultDataProcessed) {
            Swal.fire({
                allowEscapeKey: false,
                allowOutsideClick: false,
                confirmButtonText: 'Ver más eventos',
                icon: 'success',
                text: 'Consulte su correo electrónico para más información.',
                title: "Sus datos han sido recibidos exitosamente.",
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.replace('https://www.cibnor.gob.mx/catalogo-de-eventos');
                }
            }); 
        } else {
            // Notificar del error al usuario
            Swal.fire({
                allowEscapeKey: false,
                // allowOutsideClick: false,
                title: "Sucedío un error de comunicación.",
                text: 'Por favor intente nuevamente en 12 horas.',
                icon: 'error',
                showConfirmButton: false,
                footer: 'El área correspondiente ya ha sido notificada.'
            }); 
        }
        
    }

    // Procesamiento de la info
    const isDataProcessed = async() => {
        
        console.log({event});
        console.log({formValues});
        const infoAdicional = JSON.parse(formValues.infoAdicional);
        // return false;

        const solicitanteID = infoAdicional.educonResponsableId || '494';

        // Subir comprobante de pago
        const fileName = `${ formValues.registroReferencia }_compPago.pdf`
        const resultUpload = await uploadFile({ file, fileName });
        if (resultUpload.exito === 0) { return false; }
        console.log(resultUpload);

        // - URL del comprobante recien subido
        const urlArchivo = `https://eventos.cibnor.mx/registro/apiServiciosSIARF${ resultUpload.data }`;

        //* 
        //* PROCEDIMIENTO Insertar solicitud de factura en cib-store
        //* 
        // - Inicializamos lo que se enviara a insertSolicitudFactura
        let values = {
            archivoPDF: urlArchivo,
            correoElectronico: partCorreo,
            correoEvento: event.correoEvento,
            ejercicio: moment().format("YYYY"),
            envioSolicitud: "educon",
            fecha: moment().format('YYYY-MM-DDTHH:mm:ss'),
            formaPago: formaPago,
            importe: importe,
            NumeroRegistro: registroReferencia,
            proyecto: event.claveProyecto,
            quienRegistro: solicitanteID,
            solicitanteID: solicitanteID,
            telefonoCliente: '',
        };

        //* Valores para: no es extranjero y no requiere factura
        if (formValues.factExtranjero === false && formValues.requiereFactura === false) {

            const { data } = await getOneInById({ table: 'CatalogoClientes', id: '3' });
            const client = data[0];

            values.codigoPostal = client.codigoPostal;
            values.nombreCliente = `${ formValues.partNombres.trim() } ${ formValues.partApellidoPaterno.trim() } ${ formValues.partApellidoMaterno.trim() }`;
            values.regimenFiscalID = '616';
            values.rfcCliente = client.rfcCliente;
            values.usoCFDI = 'S01';
        } 

        //* Valores para: no es extranjero y si requiere factura
        if (formValues.factExtranjero === false && formValues.requiereFactura === true) {
            values.codigoPostal = factCP;
            values.nombreCliente = factNombre;
            values.regimenFiscalID = factRegimenFiscal;
            values.rfcCliente = factRFC;
            values.usoCFDI = factUsoCFDI;
        }
        
        //* Valores para: si es extranjero
        if (formValues.factExtranjero === true) {

            const { data } = await getOneInById({ table: 'CatalogoClientes', id: '2' });
            const client = data[0];

            values.codigoPostal = client.codigoPostal;
            values.nombreCliente = factExtNombre;
            values.regimenFiscalID = '616';
            values.rfcCliente = client.rfcCliente;
            values.usoCFDI = 'S01';

            values.extPais = factExtPais || '';
            values.extDataToInclude = factExtConcepto || '';
        }
        console.log({values});

        //* Construir el objeto a enviar a la API en cib-store 
        const requestInvoiceData = {
            nUsoCFDI: values.usoCFDI ?? "",
            nCP: values.codigoPostal ?? "",
            eAditionalData: values.extDataToInclude ?? "",
            email: values.correoElectronico ?? "",
            type: formValues.factExtranjero ? "E" : "N",
            nRFC: values.rfcCliente ?? "",
            fullName: values.nombreCliente ?? "",
            isInvoiceRequired: formValues.requiereFactura ? "Si" : "No",
            nRegimenFiscal: values.regimenFiscalID ?? "",
            archivoPDF: values.archivoPDF ?? "",
            envioSolicitud: "educon",
            metodoPago: values.formaPago ?? "",
            tipoTarjeta: "No aplica",
            // tipoTarjeta: "debit",
            importe: values.importe ?? "0",
            numeroRegistro: values.NumeroRegistro ?? "",
            proyecto: values.proyecto ?? "",
            _emails: [ values.correoEvento ]
        }


        //* Llamar el metodo en cib-store (app/api/request/invoice)
        const resultRI = await requestInvoice(requestInvoiceData);
        console.log({resultRI}); 


        //* Creamos el objeto de infoAdicional y le aumentamos los valores que recopilamos en ConfirmarRegistro
        let infoAdicionalObj = JSON.parse(formValues.infoAdicional);
        infoAdicionalObj.registroConfirmaFecha = moment().format('YYYY-MM-DDTHH:mm:ss');
        infoAdicionalObj.compPagoFecha = moment().format('YYYY-MM-DDTHH:mm:ss');
        infoAdicionalObj.compPagoURL = urlArchivo;
        infoAdicionalObj.compPagoURLLabel = 'Comprobante de pago';

        infoAdicionalObj.requiereFactura = requiereFactura ?? '';
        infoAdicionalObj.factExtranjero = factExtranjero ?? '';
        infoAdicionalObj.factExtPais = factExtPais ?? '';
        infoAdicionalObj.factExtNombre = factExtNombre ?? '';
        infoAdicionalObj.factExtConcepto = factExtConcepto ?? '';
        infoAdicionalObj.factNombre = factNombre ?? '';
        infoAdicionalObj.factRFC = factRFC ?? '';
        infoAdicionalObj.factCP = factCP ?? '';
        infoAdicionalObj.factUsoCFDI = factUsoCFDI ?? '';
        infoAdicionalObj.factRegimenFiscal = factRegimenFiscal ?? '';

        console.log({infoAdicionalObj});

        //* Grabar en la base de datos
        // Armamos los valores a enviar
        const updatedValues = {
            id: formValues.id,
            partApellidoPaterno: formValues.partApellidoPaterno,
            partApellidoMaterno: formValues.partApellidoMaterno,
            partNombres: formValues.partNombres,
            partCorreo: formValues.partCorreo,
            partPais: formValues.partPais,
            partEstado: formValues.partEstado,
            tipoRegistro: formValues.tipoRegistro,
            tipoRegistroDocURL: formValues.tipoRegistroDocURL,
            registroClaveProyecto: formValues.registroClaveProyecto,
            registroFecha: formValues.registroFecha,
            registroReferencia: formValues.registroReferencia,
            infoAdicional: JSON.stringify(infoAdicionalObj)
        }
        console.log({updatedValues});

        const resultPut = await putOneIn({ table: 'RegistroGeneral', values:updatedValues });
        // const resultPut = await putOneIn({ table:event.tabla, values:formValues });
        if (resultPut.exito === 0) { return false; }
        console.log({resultPut});

        // Mandar correo
        // - Inf. adicional
        const urlVisualiza = `https://eventos.cibnor.mx/registro/en-linea/visualizar-registro/${ formValues.registroReferencia }`;
        const aditionalData = 
            "<h3>información adicional:</h3>" +
            "<ul>" +
            `Puede consultar los detalles de su registro en <a href=${ urlVisualiza }>este enlace</a>` +
            "</ul>";

        // - Se genera el cuerpo del correo
        const msgbody = renderToString( 
            setEmailBodyConfirmPayment({ formValues, eventValues:event, urlArchivo, aditionalData }) 
        );

        // - Se genera el cc
        //* Si estas en produccion, agregale el correo del titular del evento
        const toccAddresses = (process.env.REACT_APP_TOCC_EDUCON !== '') 
        ? process.env.REACT_APP_TOCC_EDUCON + `, ${ event.correoEvento }`
        : process.env.REACT_APP_TOCC_EDUCON;

        //* Si estas en produccion, agregale el bcc para caja
        let tobccAddresses = (process.env.REACT_APP_TOCC_EDUCON !== '') 
        ? process.env.REACT_APP_TOBCC_FACTURACION
        : '';

        //* - Se envia el correo
        const emailResult = await sendEmail({
            "toemail": partCorreo,
            "subject": `[${ formValues.registroReferencia } ] ${ event.tituloEvento }`,
            "message": msgbody,
            "replyto": event.correoEvento,
            "tocc": toccAddresses,
            "tobcc": tobccAddresses,
        });
        console.log({emailResult});

        return true;
    }


    
    useEffect(() => {
        document.title = "Confirmar registro CIBNOR";

        const loadInitialData = async () => {
            setIsLoading(true);

            // // Obtenemos el proyecto de la referencia bancaria
            // const numProy = ref.substring(0, 5);

            // // Recuperamos el evento
            // const resultProyDataLoaded = await getOneInByClave({ table:'EventosConRegistro', clave:numProy });
            
            // // Hubo un problema al recuperar los datos del participante, muestra sweetalert de error
            // if (resultProyDataLoaded.exito === 0) {
            //     setIsLoading(false);

            //     Swal.fire({
            //         allowEscapeKey: false,
            //         allowOutsideClick: false,
            //         title: "No existe el evento",
            //         text: `La referencia ${ref} es invalida.`,
            //         footer: "Por favor, utilice el enlace recibido por correo electrónico.",
            //         showConfirmButton: false,
            //         icon: 'error',
            //     });
            // }

            // setEvent(...resultProyDataLoaded.data);

            // const eventData = resultProyDataLoaded.data[0];
            // console.log({eventData});
            // // Recuperamos el registro
            // const resultUserDataLoaded = await getOneInByReferencia({ table:eventData.tabla, referencia:ref });
            const resultUserDataLoaded = await getOneInByReferencia({ table:'RegistroGeneral', referencia:ref });
            // console.log({resultUserDataLoaded});

            setIsLoading(false);

            // No se pudo recuperar el registro o el enlace no existe, notificar al usuario
            if (resultUserDataLoaded.exito === 0) {
                Swal.fire({
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    title: "No existe el registro.",
                    text: `La referencia ${ref} es invalida.`,
                    footer: "Por favor, utilice el enlace recibido por correo electrónico.",
                    showConfirmButton: false,
                    icon: 'error',
                });
                return;
            }

            const record = resultUserDataLoaded.data[0];
            // console.log({ record });
            
            const infoAdicionalObj = JSON.parse(record.infoAdicional);
            // console.log({ infoAdicionalObj });
            const { registroConfirmaFecha, educonSolicitudId } = infoAdicionalObj;

            //* Recuperamos los datos del evento
            // Si es un educon
            const educon = await getOneFromEduconCursosActivos(educonSolicitudId);
            // Si es un evento lo recuperamos de EventosConRegistro

            // console.log({educon});

            const currentEvent = {
                id: educon.folio,
                claveProyecto: educon.cve_Proyec,
                tituloEvento: educon.curso,
                urlLogo: "https://eventos.cibnor.mx/intranet/img/logo_cib.png",
                tabla: 'RegistroGeneral',
                solicitudFolio: educon.fechasSolicitudID,
                correoEvento: educon.correoEventos,
                urlEvento: null,
                fechaInicio: educon.fechaInicio,
                disponible: "true",
                registroActivo: "1"
            }
            setEvent(currentEvent);

            //* El comprobante "ya fue subido"
            if (registroConfirmaFecha !== '') {
                const dateToText = `${ moment(registroConfirmaFecha).format("DD-MM-YYYY") }`;
                Swal.fire({
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    title: "Ya existe el comprobante.",
                    text: `El documento se subió al sistema el ${ dateToText }.`,
                    footer: "Gracias por su interes en nuestro evento.",
                    showConfirmButton: false,
                    icon: 'success',
                });
                return;
            }

            // Este par de datos vienen en string, por lo que hay que pasarlos a boolean antes de setearlos
            record.factExtranjero = false;
            record.requiereFactura = false;
            setFormValues({
                ...formValues,
                ...record
            });
        }
        loadInitialData();
 
    }, [ref])


    
    return (
        <ThemeProvider theme={createTheme()}>
            <Container component="main" maxWidth="sm">
            <CssBaseline />
                <Box
                    sx={{
                        mt: 4,
                        mb: 8,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <Avatar
                        sx={{ width: 'auto', height: 150 }}
                        src={ event.urlLogo || 'https://eventos.cibnor.mx/intranet/img/logo_cib.png' }
                        variant="square"
                    />
                    <Typography variant="h4">Confirmación de registro</Typography>
                    <Typography variant="h6">Referencia: <strong>{ registroReferencia }</strong></Typography>
                    {/* Inicio del formulario */}
                    <Box
                        component="form"
                        noValidate
                        onSubmit={ handleSubmit }
                        sx={{ mt: 2 }}
                        autoComplete="off"
                    >
                        {/* Contenedor general */}
                        <Grid
                            container
                            maxWidth={window.innerWidth}
                            spacing={2}
                            sx={{ pt: 2 }}
                        >
                            <Grid item xs={12}>
                                <Paper elevation={2}>
                                    <Card variant="outlined">
                                        <CardContent>
                                            <Grid container spacing={2}>
                                                <Grid item xs={2}>
                                                    <Typography variant="h6" align="center" sx={{ p: 0 }}>Hola, </Typography>
                                                </Grid>
                                                <Grid item xs={10} >
                                                    <TextField
                                                        id="asesorNombres"
                                                        fullWidth
                                                        value={ partNombres + " " + partApellidoPaterno + " " + partApellidoMaterno }
                                                        helperText={ "<" + partCorreo+ ">"}
                                                        InputProps={{
                                                            readOnly: true,
                                                        }}
                                                        variant="standard"
                                                    />
                                                </Grid>
                                                {/* Label comprobante de pago */}
                                                <Grid item xs={12}>
                                                    <Typography variant="h6" align="center" sx={{ p: 2 }}>Por favor agregue su comprobante de pago y los datos de facturación.</Typography>
                                                </Grid>
                                                {/* File upload */}
                                                <Grid item xs={12} >
                                                    <TextField
                                                        type={"file"}
                                                        fullWidth
                                                        variant="standard"
                                                        onChange={e => setFileState(e)}
                                                        helperText="Archivo en formato PDF *"
                                                    />
                                                </Grid>
                                                {/* Forma de pago */}
                                                <Grid item xs={8}>
                                                    <SelectCustom 
                                                    parentCallback={handleDetallesChange}
                                                    name={"formaPago"}
                                                    label={"Forma de pago"}
                                                    variant={"standard"}
                                                    options={
                                                        dataFPs.map(({ value, label }) => (
                                                            {value:value, label:label}
                                                        ))
                                                    }
                                                    required
                                                    />
                                                </Grid>
                                                {/* Importe */}
                                                <Grid item xs={4}>
                                                    <TextField 
                                                        type={"number"}
                                                        fullWidth
                                                        inputProps={{ style: { textAlign: 'right' }}}
                                                        label="Importe *"
                                                        id="importe"
                                                        name="importe"
                                                        size="small"
                                                        value={importe}
                                                        variant={"standard"}
                                                        onChange={handleDetallesChange}
                                                    />
                                                </Grid>
                                            </Grid>

                                            {/* Switch es extranjero */}
                                            <Grid item xs={12} sx={{ pt: 3 }}>
                                                <Stack direction="row" spacing={1} alignItems="center">
                                                    <Switch 
                                                        checked={isForeigner} 
                                                        id={'factExtranjero'}
                                                        inputProps={{ 'aria-label': 'ant design' }} 
                                                        name={'factExtranjero'}
                                                        onChange={handleSwitchForeigner}
                                                        />
                                                    <Typography>{ `Soy del extranjero | I'm a foreigner` }</Typography>
                                                </Stack>
                                            </Grid>
                                            {/* Participante nacional */}
                                            <Slide in={ !isForeigner } direction="right" >
                                                <Grid item xs={12} sx={{ display:(!isForeigner ? 'flex' : 'none') }} >
                                                    {/* Facturación */}
                                                    <GroupRequireInvoice parentCallback={handleInputChange} 
                                                        mainLabel={`Requiero factura`}
                                                        variant="outlined" 
                                                    />
                                                </Grid>
                                            </Slide>
                                            {/* Participante extranjero */}
                                            <Slide in={ isForeigner } direction="left" >
                                                <Grid item xs={12} sx={{ display:(isForeigner ? 'flex' : 'none') }} >
                                                <Grid container spacing={2} sx={{ pt: 2 }} >
                                                <Grid item xs={12}>
                                                <Paper elevation={2} >
                                                <Card variant="outlined" >
                                                <CardContent>
                                                    {/* Elegir pais */}
                                                    <SelectCustom 
                                                        parentCallback={handleInputChange}
                                                        name={"factExtPais"}
                                                        label={"Pais | Country"}
                                                        variant={"standard"}
                                                        options={
                                                            dataPaises.map(({ value, label }) => (
                                                                {value:value, label:label}
                                                            ))
                                                        }
                                                        required
                                                    />
                                                    {/* A nombre de */}
                                                    <Grid item xs={12}>
                                                        <TextField 
                                                            fullWidth
                                                            label={'Factura a nombre | Invoice to name *'}
                                                            id={'factExtNombre'}
                                                            name={'factExtNombre'}
                                                            size='small'
                                                            value={factExtNombre}
                                                            variant={'standard'}
                                                            onChange={handleInputChange}
                                                        />
                                                    </Grid>
                                                    {/* A nombre de */}
                                                    <Grid item xs={12}>
                                                        <TextField 
                                                            fullWidth
                                                            label={'Aditional data'}
                                                            id={'factExtConcepto'}
                                                            name={'factExtConcepto'}
                                                            size='small'
                                                            value={factExtConcepto}
                                                            variant={'standard'}
                                                            onChange={handleInputChange}
                                                        />
                                                    </Grid>
                                                </CardContent>
                                                </Card>
                                                </Paper>
                                                </Grid>
                                                </Grid>

                                                </Grid>
                                            </Slide>


                                        </CardContent>
                                    </Card>
                                </Paper>
                            </Grid>
                        </Grid>

                        {/* Boton submit */}
                        <ButtonSubmit label={`Enviar`} />
                        {/* Footer */}
                        <Footer />
                    </Box>
                </Box>
            </Container>
            {/* Dialogo de cargando info */}
            <WaitDialog show={isLoading} />

            {/* Dialogo 'enviando la informacion' */}
            <SendingDialog show={sendingForm} />

        </ThemeProvider>
    );
};
